export default __webpack_public_path__ + "static/media/varshit.492ee16d.png";